module.exports = ""


//////////////////
// WEBPACK FOOTER
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/auth/publisher-user/logout/logout.component.html
// module id = ../../../../../src/app/auth/publisher-user/logout/logout.component.html
// module chunks = main